module.exports = __webpack_public_path__ + "3818c2e2db4f8cb01e62aa7daf1d664f.MP3";